var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarmOn24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/action/alarm_on_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/alarm_on_24px_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59965 4.15752L8.05153 2.30176L2.48438 6.94611L4.03237 8.80187L9.59965 4.15752ZM20.9483 2.30248L26.5156 6.94683L24.9675 8.80259L19.4002 4.15824L20.9483 2.30248ZM12.7359 17.6713L10.1621 15.0975L8.88129 16.3784L12.7238 20.2209L19.9738 12.9709L18.693 11.69L12.7359 17.6713ZM14.5 4.94752C8.49463 4.94752 3.62504 9.81711 3.62504 15.8225C3.62504 21.8279 8.49463 26.6975 14.5 26.6975C20.5055 26.6975 25.375 21.8279 25.375 15.8225C25.375 9.81711 20.5055 4.94752 14.5 4.94752ZM6.04171 15.8225C6.04171 20.4867 9.83587 24.2809 14.5 24.2809C19.1642 24.2809 22.9584 20.4867 22.9584 15.8225C22.9584 11.1584 19.1642 7.36419 14.5 7.36419C9.83587 7.36419 6.04171 11.1584 6.04171 15.8225Z",
    fill: "black",
    fillOpacity: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmOn24Px);
export default __webpack_public_path__ + "static/media/alarm_on_24px.5465f3602ad016c84454d54fb014f50d.svg";
export { ForwardRef as ReactComponent };